module.exports = __webpack_public_path__ + "img/two1Red.3e6e840b.jpg";